// extracted by mini-css-extract-plugin
module.exports = {"container":"LiberalBoard_container__2o_a9","image":"LiberalBoard_image__3DDWI","rule":"LiberalBoard_rule__3Qr6l"};